import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-icon-edit',
  templateUrl: './btn-icon-edit.component.html',
  styleUrls: ['./btn-icon-edit.component.css']
})
export class BtnIconEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
